import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=68509057&scoped=true&"
import script from "./ComplaintForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintForm.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintForm.vue?vue&type=style&index=0&id=68509057&lang=scss&scoped=true&"
import style1 from "./ComplaintForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68509057",
  null
  
)

export default component.exports